
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"31ef5055a8ee546d6c11dc0ec6875ddfad3557c9":"$$ACTION_0","e4ac6167c6bd18dfa42ff289f4212d6216287f2e":"checkAccountExistsAction"} */ export var checkAccountExistsAction = createServerReference("e4ac6167c6bd18dfa42ff289f4212d6216287f2e");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

